import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiReferralPromocode } from '@app/packages/api/v2/types/entities'

export const getReferralPromocode = () =>
  createApiAction('getReferralPromocode', dispatch =>
    dispatch<{ data: ApiReferralPromocode | null }>({ method: 'GET', endpoint: '/api/v2/referral_promocode' })
  )

export const getReferralPromocodeByCode = (code: string) =>
  createApiAction('getReferralPromocodeByCode', dispatch =>
    dispatch<{ data: ApiReferralPromocode }>({ method: 'GET', endpoint: urlEscaped`/api/v2/referral_promocode/${code}` })
  )
